/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ComplianceTimelineEventPayload } from './';
import {
    ComplianceTimelineEventPayloadFromJSON,
    ComplianceTimelineEventPayloadFromJSONTyped,
    ComplianceTimelineEventPayloadToJSON,
} from './';

/**
 * 
 * @export
 * @interface IdentityVerificationStatusEventTimelinePayload
 */
export interface IdentityVerificationStatusEventTimelinePayload extends ComplianceTimelineEventPayload {
    /**
     * 
     * @type {string}
     * @memberof IdentityVerificationStatusEventTimelinePayload
     */
    updatedStatus: string;
    /**
     * 
     * @type {string}
     * @memberof IdentityVerificationStatusEventTimelinePayload
     */
    providerSessionId: string;
}

/**
 * Check if a given object implements the IdentityVerificationStatusEventTimelinePayload interface.
 */
export function instanceOfIdentityVerificationStatusEventTimelinePayload(value: object): value is IdentityVerificationStatusEventTimelinePayload {
    if (!('updatedStatus' in value) || value['updatedStatus'] === undefined) return false;
    if (!('providerSessionId' in value) || value['providerSessionId'] === undefined) return false;
    return true;
}

export function IdentityVerificationStatusEventTimelinePayloadFromJSON(json: any): IdentityVerificationStatusEventTimelinePayload {
    return IdentityVerificationStatusEventTimelinePayloadFromJSONTyped(json, false);
}

export function IdentityVerificationStatusEventTimelinePayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentityVerificationStatusEventTimelinePayload {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ComplianceTimelineEventPayloadFromJSONTyped(json, ignoreDiscriminator),
        'updatedStatus': json['updatedStatus'],
        'providerSessionId': json['providerSessionId'],
    };
}

export function IdentityVerificationStatusEventTimelinePayloadToJSON(value?: IdentityVerificationStatusEventTimelinePayload | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ComplianceTimelineEventPayloadToJSON(value, true),
        'updatedStatus': value['updatedStatus'],
        'providerSessionId': value['providerSessionId'],
    };
}

